<template>
  <div id="cooperater">
    <div class="bg">
      <div>
        <div class="header">商务合作申请</div>
        <div class="box">
          <el-row :gutter="40">
            <el-col :span="12">
              <el-row class="condition-row">      
                <el-col :span="24">
                  <el-divider>业务主要城市</el-divider>
                  <div class="condition-checked" v-for="(item,index) in citys" :key="index">
                    <el-dropdown>
                      <span class="el-dropdown-link">
                        {{item.name}}<i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="selectCity(indus.name)"  v-for="(indus,idx) in item.children" :key="idx">{{indus.name}}</el-dropdown-item>                    
                      </el-dropdown-menu>            
                    </el-dropdown>
                  </div>
                </el-col>
              </el-row>
              <el-row class="condition-row">
                <el-col :span="24">
                  <el-divider>核心业务</el-divider>           
                  <span  :class="{'condition-checked':true,'tag':true,'active':tagId == item.id}"  @click="handleTags(item.id)" v-for="(item,index) in recommends" :key="index">{{item.tag}}</span>
                </el-col>
              </el-row>  
            </el-col>
            <el-col :span="12">
              <el-row class="cells">
                <el-col :span="24">
                  <el-input  placeholder="请输入联系人手机号" minlength="11" maxlength="11" v-model="phone"></el-input>
                </el-col>
              </el-row>
              <el-row class="cells">
                <el-col :span="24">
                  <el-input placeholder="请输入公司名全称" minlength="6" maxlength="30" v-model="companyname"></el-input>
                </el-col>
              </el-row>
              <el-row class="cells">
                <el-col :span="24">
                  <el-input type="textarea" placeholder="请输入企业简介" minlength="6" maxlength="30" rows="6" v-model="subtitle"></el-input>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="cells" :gutter="40">
            <el-col :span="12">
              <el-input placeholder="请输入企业网站链接（没有可不填）" v-model="website_url"></el-input>
            </el-col>
            <el-col :span="12">
              <el-button type="primary" style="width:100%" :loading="loading"  @click="doSubmit">{{msg}}</el-button>
            </el-col>       
          </el-row>                  
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import helpers from '../helper';
import citys from '../utils/citys.js';
export default {
  name:'cooperater',
  data(){
    return {      
      recommends:[],
      loading:false,
      disabled:false,
      msg:"立即提交",
      citys:citys,
      city:"",
      tagId:null,
      phone:null,
      companyname:'',
      subtitle:'',
      website_url:''
    }
  },
  methods:{
    handleTags(tagId){
      this.tagId = tagId;
    },
    selectCity(cityName){      
      this.city = cityName;
    },
    doSubmit(){
      let city = this.city;
      let tagId = this.tagId;
      let phone = this.phone;
      let companyname = this.companyname;
      let subtitle = this.subtitle;
      let website_url = this.website_url;

      
      if(city == "" || tagId == null || phone == null || companyname == "" || subtitle == ""){
        return this.$message.error("请完善所有信息")
      }
      if(phone.length != 11){
        return this.$message.error("请填写正确的手机号")
      }
      this.loading = true
      this.msg = "正在提交..."
      let _this = this 
      this.$http.post(
        helpers.BASE_URL + '/api/home/index/managerSupplyCompany',
        {city,tagId,phone,companyname,subtitle,website_url}
      ).then(function(response){
        //console.log(response.data.msg)
        _this.loading = false
        _this.msg = "立即提交"
        if(response.data.code === 0){
          return _this.$message.error(response.data.msg)
        }
        return _this.$message({
            message:response.data.msg,
            type:'success'
          })
      });
    },
    init(){
      let _this = this;
      this.$http.get(
        helpers.BASE_URL + '/api/home/index/getRecommendTags'
      ).then(function(response){
        //console.log(response.data.data)
        if(response.data.code === 1){
          _this.recommends = response.data.data;
        }
      });
    }
  },
  created(){
    this.init()
  }
}
</script>
<style scoped>
.bg{
  background-image: url(../assets/images/login_bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #59daf7;
  width: 100%;
  height:100vh;
}
.header{
  font-size: 28px;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  padding-top: 40px;
}
.box{
  background-color:#ffffff;
  padding: 40px 80px;
  width: 46vw;
  margin: 40px auto;
}
.cells{
  margin-top: 20px;
}
.cells:nth-last-child(1){
  margin-top: 20px;
  font-size: 12px;
}
.cells:nth-last-child(1) a{
  color: #939393;
}
.verify{
  width: 100%;
  height:40px
}
.condition-checked{
  margin: 5px 6px 0 0;
  padding: 2px 5px ;
  float: left;
  word-wrap:break-word;
}
.condition-row{
  margin-bottom: 4px;
}
.condition-head{
  font-size: 14px;
  margin-right: 40px;
  display: inline-block;
  width: 80px;
  text-align: right;
}
.el-dropdown-link {
  cursor: pointer;
  color: #939393;
}
.el-dropdown-link:hover{
  color: #0bc8f4!important;
}
.el-dropdown-menu__item{
  line-height: 24px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.tag{
  font-size: 14px;
  color: #939393;
  cursor: pointer;  
}
.tag:hover{
  background-color: #0bc8f4;
  color: #ffffff;
  border-radius: 4px;
}
.active{
  background-color: #0bc8f4;
  color: #ffffff;
  border-radius: 4px;
}
</style>
